module.exports = __webpack_public_path__ + "static/media/google.6d1b4c8b.svg";